import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';
import { popperControlOptions } from '@bazis/form/models/form-element.types';
import { BazisAutocompleteStaticComponent } from '@bazis/form/components/base/autocomplete/autocomplete-static.component';

@Component({
    selector: 'app-autocomplete-static-inside',
    templateUrl: './autocomplete-static-inside.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class AutocompleteStaticInsideComponent
    extends BazisAutocompleteStaticComponent
    implements OnInit
{
    ngOnInit(): void {
        super.ngOnInit();
        this.popperOptions = {
            modifiers: [
                ...popperControlOptions.modifiers,
                {
                    name: 'offset',
                    options: {
                        offset: ({ placement }) => {
                            if (placement === 'top-start') {
                                return [0, 24];
                            } else {
                                return [0, 6];
                            }
                        },
                    },
                },
            ],
        };
    }
}
